<template>
  <div id="app" :class="activIndex&&isShowNav()?'activ':''">
    <head-title v-if="isShowNav()&&activIndex"></head-title>
    <router-view />
    <navBars v-if="isShowNav()&&activIndex"></navBars>
  </div>
</template>
<script>
import navBars from "@/components/navBar.vue"
import headTitle from "@/components/headTitle.vue"
export default {
  data() {
    return {
      activIndex:false
    }
  },
  components: {
    navBars,
    headTitle
  },
  mounted() {
    this.activ()
  },
  methods: {
    //登录页不显示头部和底部
    isShowNav() {
      if (this.$route.path == '/login') {
        return false
      } else {
        return true
      }
    },
    activ() {
      var browser = require("browser-tool");
      if (browser().device == 'PC') {
        this.activIndex = false
      }
      else if (( browser().device == 'Mobile')&&this.$route.path!='/newhomepage') {
        this.activIndex = true
      }
    }

  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.activ{
  background-color: #f6f7fc;
  padding-top: 163px;
}
</style>
